module.exports = __webpack_public_path__ + "img/Feature.6d46d09b.png";